/* eslint-disable jsx-a11y/control-has-associated-label */
import { flow } from 'lodash';
import React, { FunctionComponent, useMemo } from 'react';
import { DownloadIcon } from '../../../../Icons';
import styles from './DocsPurchaseTab.module.scss';
import { DocsPurchaseTabProps } from './DocsPurchaseTab.type';
import { getFileSize } from '../../../../../utils/getFileSize';
import { PurchaseDoc } from '../../../../../types/entities';
import { getTemplateConfig } from '../../../../Purchases/hooks/getTemplateConfig';
import StubAuthRequired from '../../../../Purchases/components/StubAuthRequired';

const DocsPurchaseTab: FunctionComponent<DocsPurchaseTabProps> = ({
    purchase,
}) => {
    const isInfoRestricted = useMemo(
        () => getTemplateConfig(purchase).publicAnnounceTabDocs?.isHidden,
        [purchase]
    );
    return isInfoRestricted ? (
        <StubAuthRequired />
    ) : (
        <div className={styles.container}>
            <ol className={styles.list}>
                {purchase?.docs?.map((doc: PurchaseDoc, docIdx: number) => {
                    return (
                        <li
                            key={`${doc?.id}-${doc?.fileId}`}
                            className={styles.item}
                        >
                            <div className={styles.index}>{docIdx + 1}</div>
                            <div className={styles.title}>
                                <a
                                    href={doc?.downloadUri}
                                    title={doc?.file?.originalName}
                                >
                                    {doc?.file?.originalName}
                                </a>
                                <p>{doc.docRef.title}</p>
                            </div>
                            <div className={styles.size}>
                                {getFileSize(doc?.file?.fileSize)}
                            </div>
                            <a href={doc?.downloadUri}>
                                <DownloadIcon />
                            </a>
                        </li>
                    );
                })}
            </ol>
        </div>
    );
};

export default flow(() => DocsPurchaseTab)();
